<div class="container">
    <div class="col mt-4 mb-4 d-flex justify-content-center">
        <button class="btn btn-lg btn-dark rounded" (click)="navigate('')">INICIO</button>
    </div>
</div>